const cache = new Map<string, { count: number; timestamp: number }>();

const eventEmitter = new EventTarget();

export const invalidateUnreadReviewsCache = (userId?: string) => {
    if (userId) {
        cache.delete(userId);
        eventEmitter.dispatchEvent(new CustomEvent('cache-invalidated', { detail: { userId } }));
    } else {
        cache.clear();
        eventEmitter.dispatchEvent(
            new CustomEvent('cache-invalidated', { detail: { userId: 'all' } }),
        );
    }
};
